import { DateFormatEnum, formatStringToDate, isValidDate } from "@core/utils";
import { AbstractOptionalValidation } from "./abstractOptionalValidation";
import { CustomErrorMessage } from "@generation/form/src/Validations/ValidationHelper";

export class DateNotInFutureValidation extends AbstractOptionalValidation {
  key = "isDateNotInFuture";

  validateValue(value: string): boolean {
    if (isValidDate(value as unknown as string, DateFormatEnum.Date)) {
      const date = formatStringToDate(value as unknown as string, DateFormatEnum.Date);
      return date < new Date();
    }
    return false;
  }
}
